import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-monitor-extrato-dialog",
  templateUrl: "monitor-extrato-dialog.component.html",
  styleUrls: ["./monitor-extrato-dialog.component.scss"],
})
export class MonitorExtratoDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<MonitorExtratoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  dataSource: any = null;
  displayedColumns = ["column1", "column2", "column3"];

  ngOnInit() {
    this.dataSource = [
      { column1: "coluna 1", column2: "coluna 2", column3: "coluna 3" },
      { column1: "coluna 1", column2: "coluna 2", column3: "coluna 3" },
      { column1: "coluna 1", column2: "coluna 2", column3: "coluna 3" },
      { column1: "coluna 1", column2: "coluna 2", column3: "coluna 3" },
      { column1: "coluna 1", column2: "coluna 2", column3: "coluna 3" },
      { column1: "coluna 1", column2: "coluna 2", column3: "coluna 3" },
      { column1: "coluna 1", column2: "coluna 2", column3: "coluna 3" },
      { column1: "coluna 1", column2: "coluna 2", column3: "coluna 3" },
      { column1: "coluna 1", column2: "coluna 2", column3: "coluna 3" },
      { column1: "coluna 1", column2: "coluna 2", column3: "coluna 3" },
      { column1: "coluna 1", column2: "coluna 2", column3: "coluna 3" },
      { column1: "coluna 1", column2: "coluna 2", column3: "coluna 3" },
      { column1: "coluna 1", column2: "coluna 2", column3: "coluna 3" },
    ];
  }
}
